import { Card, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { POST } from "../../utils/apicalls";
import { API } from "../../config/api";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { GrView } from "react-icons/gr";
import PageHeader from "../../admin/pageHeader/pageheader";

function ClientProject() {
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const columns = [
    {
      dataIndex: "projectName",
      title: "projectName",
    },
    {
      title: "status",
      dataIndex: "status",
    },
    {
      key: "assignedTo",
      dataIndex: "assignedTo",
      title: "assignedTo",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    // {
    //   dataIndex: "clientid",
    //   title: "clientid",
    //   key: "clientid",
    //   render: (_: any, value: any) => <span>{value?.Client?.companyName}</span>,
    // },
    {
      dataIndex: "startDate",
      title: "startDate",
      render: (start_date: any) =>
        start_date ? moment(start_date).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "endDate",
      title: "endDate",
      render: (end_date: any) =>
        end_date ? moment(end_date).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "projectType",
      title: "projectType",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() =>
              navigate(`/Client/Project_details/projectview/${record?.id}`)
            }
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    filterProject();
  }, []);
  const filterProject = async () => {
    try {
      setIsLoading(true);
      let obj = {
        clientid: Number(user.id),
        status: true,
      };
      const url = API.PROJECT_FILTERING;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageHeader />
      <Card>
        <h2 style={{ textAlign: "center" }}>Project Details</h2>
        <Table columns={columns} dataSource={data} />
      </Card>
    </div>
  );
}

export default ClientProject;
